import { z } from 'zod';

import { ShotLoad, ShotResult } from '../../statistics';

export type SessionReportUiState = z.output<typeof sessionReportUiStateSchema>;
export type SessionReportUiStateDTO = z.input<typeof sessionReportUiStateSchema>;

export const sessionReportUiStateSchema = z.object({
  performanceStats: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
  shotAreas: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
    }),
  shotLoad: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
      selectedShotLoad: z.enum(ShotLoad).catch(ShotLoad.HIGH),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
      selectedShotLoad: ShotLoad.HIGH,
    }),
  shotMap: z
    .object({
      expanded: z.boolean().catch(true),
      result: z.enum(ShotResult).nullable().catch(null),
    })
    .catch({
      expanded: true,
      result: null,
    }),
  shotStats: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
});
